// extracted by mini-css-extract-plugin
module.exports = {"NotificationsTable":"Notification_NotificationsTable__17Mhv","PlateNumber":"Notification_PlateNumber__2rOig","BulletPoint":"Notification_BulletPoint__1txDh"};